// extracted by mini-css-extract-plugin
module.exports = {"toc":"toc-module--toc--1NDho","tocActive":"toc-module--toc-active--MJuwZ"};